/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect } from 'react'
import { Modal, Spin } from 'antd'
import { useForm } from 'react-hook-form'
import { CloseOutlined } from '@ant-design/icons'

import { DeleteTicketNotificationContext } from '@contexts'
import { useDeleteTicket } from '@hooks'

import { StyledRow } from '../StyledComponents'

type Props = {
  open: boolean
  onClose: () => void
  title: string
  ticketId: number
  isLoading: boolean
}

const DeleteTicketModal: React.FC<Props> = ({ open, onClose, title, ticketId }) => {
  const { deleteTicket, isLoading: isDeleteTicketLoading } = useDeleteTicket()
  const { setTicketDeleteId } = useContext(DeleteTicketNotificationContext)
  const { handleSubmit } = useForm()

  const handleDeleteTicket = useCallback(() => {
    deleteTicket(ticketId)
  }, [ticketId])

  useEffect(() => {
    setTicketDeleteId(ticketId)
  }, [ticketId])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={title}
      closeIcon={<CloseOutlined />}
      okText="Eliminar"
      cancelText="Cancelar"
      onOk={handleSubmit(handleDeleteTicket)}
      confirmLoading={isDeleteTicketLoading}
    >
      <Spin spinning={isDeleteTicketLoading}>
        <StyledRow>{`¿Desea borrar el ticket ${ticketId}?`}</StyledRow>
      </Spin>
    </Modal>
  )
}

export { DeleteTicketModal }
